import React, { Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import VerticalLayout from '../layouts/VerticalLayout';
import { useAuth } from "../context/AuthContext";
//routes
import { authProtectedRoutes, publicRoutes, isValidRoute } from "./AllRoutes";
import { AuthProtected } from './AuthProtected';

const Index = () => {
    const authCtx = useAuth();
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <Suspense fallback={
            <div className="spinner-border text-info" style={{ position: 'fixed', left: '50%', right: '50%', top: '50%' }}>
                <span className="sr-only"></span>
            </div>
            }
        >
            <Routes>
                <Route>
                    {!authCtx.isAuthenticated && publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                route.element
                            }
                            key={route.path}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected location={route.path}>
                                    <VerticalLayout>{route.element}</VerticalLayout>
                                </AuthProtected>}
                            key={route.path}
                        />
                    ))}
                </Route>

                <Route path="*" element={
                    isValidRoute(currentPath) ? (
                        <Navigate to={currentPath} />
                    ) : (
                        // <Navigate to="/home" />
                        <Navigate to="/planner" />
                    )
                } />
            </Routes>
        </Suspense>
    );
};

export default Index;